import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bbc70c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_select_down" }, "▼", -1))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "v-select-open"
}
const _hoisted_4 = { value: "0" }
const _hoisted_5 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isMobile())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "v-select-open",
        style: _normalizeStyle({
      zIndex: _ctx.react.z_index,
      marginTop: _ctx.react.margin_top,
      width: _ctx.react.width,
    })
      }, [
        (_openBlock(), _createElementBlock("p", {
          class: "main_select_desktop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.react.hide_bool = !_ctx.react.hide_bool)),
          key: _ctx.react.title
        }, [
          _createTextVNode(_toDisplayString(_ctx.deff_title) + " ", 1),
          _hoisted_1
        ])),
        _createElementVNode("div", {
          class: _normalizeClass(["options", { hide: _ctx.react.hide_bool }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("span", {
              key: option.value,
              class: "main_select_option",
              onClick: ($event: any) => (_ctx.selectOption(option))
            }, _toDisplayString(option.name), 9, _hoisted_2))
          }), 128))
        ], 2)
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("select", {
          class: "main_select",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectOption_sel && _ctx.selectOption_sel(...args)))
        }, [
          _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.react.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.react.options, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.value,
              value: option.value,
              selected: _ctx.deff_select === option.value
            }, _toDisplayString(option.name), 9, _hoisted_5))
          }), 128))
        ], 32)
      ]))
}